export default __webpack_public_path__ + "static/media/memTeam4.967dc407.png";